import { env } from '@didi/utils'
import bridge from './bridge'
import { invokeEntrance } from './share'
import { omega } from '@didi/driver-biz-sdk'
import { ActionSheet } from 'cube-ui'
import { Modal } from '@didi/driver-biz-ui'
import router from '@/router'
import { showReauthorizeModal } from 'common/biz/reauthorize-modal'
import { getMyInsurancePolicies } from '@/api'
import { QA_URL, RULE_URL } from '@/common/biz/constants'

declare global {
  interface Window { addCornerButton: () => void; }
}
function addCornerButton(params: {
  btnName: string
}, cb: () => void = () => { /** empty fn */ }) {
  function _addCornerButtonCb() { cb() }
  window.addCornerButton = _addCornerButtonCb
  bridge.addCornerButton({
    btnName: params.btnName,
    jsCallback: 'addCornerButton'
  }, _addCornerButtonCb)
}

export function addCornerButtonShare(): void {
  console.log('分享')
  if (env.isDriver || env.rainbow) {
    let disabled = false
    setTimeout(() => {
      addCornerButton({
        btnName: '分享'
      }, function() {
        omega.trackEvent('am_c_insure_endowmentbjion_share_ck', {
          type: 1
        })
        if (disabled) return
        disabled = true
        invokeEntrance()
        setTimeout(() => {
          disabled = false
        }, 600)
      })
    }, 900)
  }
}

// contentType 1只有补贴，2只有自费，3都有
export function addCornerButtonMore(info: { status: number, companyId: number, authProductLine: number, allCompanyIds: number[], contentType: 1|2|3, qaLink: string, ruleLink: string }): void {
  setTimeout(() => {
    const dom = document.querySelector('.banner-more')
    if (dom) {
      dom.addEventListener('click', () => {
        showAction(info)
      })
    }
  }, 3000)
  if (env.isDriver || env.rainbow) {
    setTimeout(() => {
      addCornerButton({ btnName: '•••' }, () => {
        showAction(info)
      })
    }, 900)
  }
}

export function hideCornerButtonMore(): void {
  if (env.isDriver || env.rainbow) {
    addCornerButton({
      btnName: ' '
    }, function() {
      // empty fn
    })
  }
}

let actionSheet
export function showAction({
  status,
  authProductLine,
  allCompanyIds,
  contentType,
  ruleLink,
  qaLink
}: {
  status: number, authProductLine: number, allCompanyIds: number[], contentType: 1|2|3, qaLink: string, ruleLink: string
}): void {
  if (!actionSheet) {
    const options = [{ content: '分享' }, { content: '常见问题' }, { content: '详细规则' }, { content: '查看协议' }]
    if (status === 1 || status === 2) {
      options.push({ content: '退保引导' })
    } else if (contentType === 2 || contentType === 3) {
      options.push({ content: '退保引导' })
    }
    if (authProductLine) {
      options.push({ content: '重新授权' })
    }
    actionSheet = ActionSheet.$create({
      // eslint-disable-next-line
      // @ts-ignore
      $class: { 'action-sheet-overwrite': true },
      pickerStyle: true,
      data: options,
      onSelect: ({ content: item }) => {
        if (item === '分享') {
          omega.trackEvent('am_c_insure_medinsurland_share_ck')
          invokeEntrance()
        } else if (item === '查看协议') {
          router.push({
            path: '/protocol-list',
            query: {
              contentType: contentType + ''
            }
          })
        } else if (item === '退保引导') {
          omega.trackEvent('am_c_insure_medinsurpolicy_dpolicyg_ck')
          let content = '<p>请根据保单承保保司，选择对应联系方式进行办理：</p>'
          getMyInsurancePolicies({ insurance_id: 1100 }).then(res => {
            const arr = [...allCompanyIds]
            res.forEach(item => {
              if (!arr.includes(item.company_id)) {
                arr.push(item.company_id)
              }
            })
            arr.forEach((item) => {
              const contentMap = {
                20001: '<p>【中国人保】：</p><p style="font-size: 14px">请拨打客服热线“4009191133”联系办理；</p>',
                20002: '<p>【太平洋保险】：</p><p style="font-size: 14px">-. 请拨打客服热线“95500”联系办理；</p><p style="font-size: 14px">-. 到【太平洋保险】保险公司的线下门店联系办理；</p>',
                20003: '<p>【众诚汽车保险】：</p><p style="font-size: 14px">请拨打客服热线“4008600600”联系办理；</p>',
                20004: '<p>【大家财险】：</p><p style="font-size: 14px">请拨打客服热线“95569-2”联系办理；</p>'
              }
              if (contentMap[item]) {
                content = content + contentMap[item]
              }
            })
            Modal.$create({
              // eslint-disable-next-line
              // @ts-ignore
              $class: {
                'biz-modal-overwrite': true
              },
              type: 'confirm',
              content,
              confirmBtn: '我知道了'
            }).show()
          })
        } else if (item === '重新授权') {
          showReauthorizeModal(authProductLine)
        } else if (item === '常见问题') {
          window.location.href = qaLink || QA_URL
        } else if (item === '详细规则') {
          window.location.href = ruleLink || RULE_URL
        }
      }
    })
  }
  actionSheet.show()
}
